import React, { useState, useEffect } from 'react';
import { Platform, View } from 'react-native';

interface ResioLogoProps {
  width?: number;
  height?: number;
  style?: any;
  className?: string; // For web compatibility
}

export const ResioLogo = ({ width = 64, height = 64, style, className = "" }: ResioLogoProps) => {
  const [SvgComponents, setSvgComponents] = useState<any>(null);
  const [gradientId] = useState(() => `resio-gradient-${Math.random().toString(36).substr(2, 9)}`);

  useEffect(() => {
    // Only load react-native-svg for mobile platforms
    if (Platform.OS !== 'web') {
      import('react-native-svg')
        .then((svgModule) => {
          setSvgComponents(svgModule);
        })
        .catch((error) => {
          console.warn('Failed to load react-native-svg:', error);
        });
    }
  }, []);

  if (Platform.OS === 'web') {
    // Web version using regular SVG
    return (
      <svg 
        viewBox="0 0 37 52" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className={className}
        style={{ width, height, ...style }}
      >
        <path
          d="M0 43.4795V12.0572C0 5.40644 5.42457 0 12.0969 0H24.1204C30.7885 0 36.2174 5.40644 36.2174 12.0572V43.4795H8.04792V14.0467C8.05317 12.447 8.69233 10.9147 9.82534 9.7854C10.9583 8.65611 12.4928 8.022 14.0925 8.02201H22.1231C23.7228 8.022 25.2573 8.65611 26.3903 9.7854C27.5233 10.9147 28.1625 12.447 28.1677 14.0467V35.6984H16.0967V16.0242H20.1198V31.6908H24.1438V14.0467C24.1426 13.512 23.9293 12.9995 23.5505 12.6219C23.1718 12.2444 22.6588 12.0326 22.124 12.033H14.0934C13.5586 12.0326 13.0455 12.2444 12.6668 12.6219C12.2881 12.9995 12.0747 13.512 12.0736 14.0467V39.7094H32.1934V12.0572C32.1934 7.62134 28.571 4.01101 24.1204 4.01101H12.0969C7.64552 4.01101 4.02396 7.62134 4.02396 12.0572V47.7314H36.2174V51.5015H0V43.4795Z"
          fill={`url(#${gradientId})`}
        />
        <defs>
          <linearGradient
            id={gradientId}
            x1="18.1916"
            y1="-4.88401"
            x2="18.0638"
            y2="51.5006"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.19" stopColor="#4773FE" />
            <stop offset="0.67" stopColor="#BE5EC8" />
            <stop offset="0.98" stopColor="#F55560" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  // React Native version - dynamically loaded
  if (!SvgComponents) {
    // Return a placeholder while loading or if SVG components failed to load
    return <View style={[{ width, height, backgroundColor: '#4773FE' }, style]} />;
  }

  const { default: Svg, Path, Defs, LinearGradient, Stop } = SvgComponents;

  return (
    <Svg 
      width={width} 
      height={height} 
      viewBox="0 0 37 52" 
      fill="none" 
      style={style}
    >
      <Defs>
        <LinearGradient
          id={`${gradientId}_mobile`}
          x1="18.1916"
          y1="-4.88401"
          x2="18.0638"
          y2="51.5006"
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset="0.19" stopColor="#4773FE" />
          <Stop offset="0.67" stopColor="#BE5EC8" />
          <Stop offset="0.98" stopColor="#F55560" />
        </LinearGradient>
      </Defs>
      <Path
        d="M0 43.4795V12.0572C0 5.40644 5.42457 0 12.0969 0H24.1204C30.7885 0 36.2174 5.40644 36.2174 12.0572V43.4795H8.04792V14.0467C8.05317 12.447 8.69233 10.9147 9.82534 9.7854C10.9583 8.65611 12.4928 8.022 14.0925 8.02201H22.1231C23.7228 8.022 25.2573 8.65611 26.3903 9.7854C27.5233 10.9147 28.1625 12.447 28.1677 14.0467V35.6984H16.0967V16.0242H20.1198V31.6908H24.1438V14.0467C24.1426 13.512 23.9293 12.9995 23.5505 12.6219C23.1718 12.2444 22.6588 12.0326 22.124 12.033H14.0934C13.5586 12.0326 13.0455 12.2444 12.6668 12.6219C12.2881 12.9995 12.0747 13.512 12.0736 14.0467V39.7094H32.1934V12.0572C32.1934 7.62134 28.571 4.01101 24.1204 4.01101H12.0969C7.64552 4.01101 4.02396 7.62134 4.02396 12.0572V47.7314H36.2174V51.5015H0V43.4795Z"
        fill={`url(#${gradientId}_mobile)`}
      />
    </Svg>
  );
};
